import { render, staticRenderFns } from "./DocumentsFilterForm.vue?vue&type=template&id=9df6b064"
import script from "./DocumentsFilterForm.vue?vue&type=script&lang=js"
export * from "./DocumentsFilterForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentsFilterForm.vue?vue&type=style&index=0&id=9df6b064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports